import { Box } from '@twilio-paste/core/box';

import { ViewLoadingState } from '../ViewLoadingState';

const defaultWidths = [
  '80%',
  '60%',
  '40%',
  '20%',
  '0p%',
  '0%',
  '80%',
  '50%',
  '60%',
  '0%',
  '80%',
  '60%',
  '20%',
];

export const FormDrawerLoadingState = () => (
  <Box margin="space80">
    <ViewLoadingState widths={defaultWidths} />
  </Box>
);
